/* Shared custom element also initializes newly inserted Theme Editor sections. */
if (!customElements.get('louielou-adult-waitlist')) {
  customElements.define('louielou-adult-waitlist', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const form = this.querySelector('form');
      if (!form) return;
      this.initialized = true;
      this.dataset.ready = 'true';
      form.elements.email.disabled = false;
      form.querySelector('button[type="submit"]').disabled = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.pending || !form.reportValidity()) return;
        const error = this.querySelector('[data-error]');
        const success = this.querySelector('[data-success]');
        const fields = this.querySelector('[data-fields]');
        const preview = this.querySelector('[data-preview]');
        error.hidden = true;
        if (this.dataset.designMode === 'true') {
          preview.hidden = false;
          preview.focus();
          return;
        }
        if (form.elements.website.value) return;
        const button = form.querySelector('button[type="submit"]');
        const originalText = button.textContent;
        this.pending = true;
        button.disabled = true;
        button.textContent = this.dataset.pendingText;
        form.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch('https://louielou-restock.louielou-store.workers.dev', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            signal: controller.signal,
            body: JSON.stringify({
              email: form.elements.email.value.trim(),
              restock_tag: 'restock-vuxenfiltar',
              product_handle: 'vuxenfiltar',
              product_title: 'Louie Lou vuxenfiltar',
              product_url: window.location.origin + window.location.pathname + '#' + this.closest('section').id
            })
          });
          if (!response.ok) throw new Error('Signup failed');
          const result = await response.json();
          if (result.ok !== true) throw new Error('Signup not confirmed');
          fields.hidden = true;
          success.hidden = false;
          success.focus();
          form.elements.email.value = '';
        } catch (_) {
          error.hidden = false;
          error.focus();
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          button.disabled = false;
          button.textContent = originalText;
          form.removeAttribute('aria-busy');
        }
      });
    }
  });
}
